















import {Component, Mixins, Vue, Prop, Ref} from 'vue-property-decorator';
import {Mixin} from "@/mixins";
import ProductList from "@/components/ProductList.vue";
import AdditionalOptions from "@/components/AdditionalOptions.vue";
import store from "@/store";
import CartOptions from "@/components/CartOptions.vue";

@Component({
    components: {
        CartOptions,
        AdditionalOptions,
        ProductList,
    }
})
export default class Cart extends Mixins(Mixin) {
    //<editor-fold desc="Private properties">
    store = store();
    optionsButtonVisible = false;
    //</editor-fold>

    //<editor-fold desc="Props">
    //</editor-fold>

    //<editor-fold desc="Refs">
    @Ref()
    cartOptions!: Vue;
    //</editor-fold>

    //<editor-fold desc="Watchers">
    //</editor-fold>

    //<editor-fold desc="Getters">
    get lastMonthDay(): string {
        let today = new Date();
        let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return this.printDate(lastDayOfMonth);
    }

    //</editor-fold>

    //<editor-fold desc="Hooks">
    mounted() {
        this.onScroll();
        document.addEventListener('firstCartAjax', this.onScroll);
        window.addEventListener('scroll', this.onScroll);

        document.querySelectorAll('.header-inside > *').forEach((el) => {
            (el as HTMLElement).style.removeProperty('display');
        });

        document.querySelectorAll('.header-inside > .hide-in-cart').forEach((el) => {
            (el as HTMLElement).style.setProperty('display', 'none', 'important');
        });
    }

    beforeDestroy() {
        document.removeEventListener('firstCartAjax', this.onScroll);
        window.removeEventListener('scroll', this.onScroll);
    }

    //</editor-fold>

    //<editor-fold desc="Methods">
    onScroll() {
        if (this.cartOptions && this.store.serverData.additionalOptions.assemblyData) {
            const cartOptionsClientTop = this.cartOptions.$el.getBoundingClientRect().top;
            this.optionsButtonVisible = cartOptionsClientTop > window.innerHeight;
        }
    }

    scrollToCartOptions() {
        if (this.cartOptions && this.store.serverData.additionalOptions.assemblyData) {
            const top = this.cartOptions.$el.getBoundingClientRect().top
                + window.scrollY
                - ((<HTMLDivElement>document.getElementById('header')).clientHeight)
                - 5;
            window.scroll({
                top,
                behavior: 'smooth',
            });
        }
    }

    //</editor-fold>
}
